import { FEATURES } from '@/src/constants/Text'

// Deep-link para Configurações › Jurídico (aba "Importação de Dados").
// Transportado por `query` (não `params`): settings/routes.js declara
// `settings-v2.juridico` com `redirect` por STRING de path, e o Vue Router 3
// descarta `params` ao resolver redirect por path — só `query` atravessa
// intacto e sobrevive a F5. Ver captable-partnership.vue `openCorporatePool`
// e settings/views/juridico/view-modulo-juridico.vue `toImportData`.
export const JURIDICO_TAB_IMPORTACAO_DADOS = '1'
export const JURIDICO_FILTRO_CAPTABLE = 'Captable'

export const captableRoutes = (show, currentUser) => {
  const optionsRoutes = [
    {
      name: 'captable.visao_geral',
      slug: 'visao_geral',
      title: 'Visão geral',
      subtitle:
        'Aqui você tem uma visão geral do Pool societário, Partnership, contratos e compliance.',
      hasAccess: true,
    },
    {
      name: 'captable.partnership',
      slug: 'partnership',
      title: 'Partnership',
      subtitle: 'Aqui você gerencia sua estrutura societária.',
      hasAccess: true,
    },
    {
      name: 'captable.controle_partnership',
      slug: 'controle-partnership',
      title: 'Controle Partnership',
      subtitle: 'Gerencie compras, vendas e pagamentos das rodadas.',
      hasAccess: true,
    },
    {
      name: 'captable.contracts',
      slug: 'contratos',
      title: 'Contratos',
      subtitle: 'Aqui você visualiza seus contratos, kit societário e modelos.',
      hasAccess: show.contracts,
    },
    {
      name: 'captable.kit_partners',
      slug: 'kit-socios',
      title: 'Kit Societário',
      subtitle: 'Gerencie os kits de documentos societários por PJ.',
      hasAccess: show[FEATURES.KIT_SOCIETARIO],
    },
    {
      name: 'captable.templates',
      slug: 'templates',
      title: 'Modelos',
      subtitle: 'Aqui você gerencia seus modelos de contratos.',
      hasAccess: show[FEATURES.MODELOS],
    },
  ]

  return optionsRoutes.filter((item) => {
    return item.hasAccess
  })
}
